import React from "react";
import { Modal } from "rsuite";
import { useAppSelector, useAppDispatch } from "../../core/redux/reduxStore";
import { ActionUI } from "../../core/redux/slices/sliceUI";
import { useEffect } from "react";

export const AddUserEmailModal = () => {
  const dispatch = useAppDispatch();
  const { addUserEmailModal } = useAppSelector((state) => state.ui);
  const handleClose = () => dispatch(ActionUI.setAddUserEmailModalView({ ...addUserEmailModal, show: false }));
  return (
    <Modal open={addUserEmailModal?.show} onClose={handleClose}>
      <Modal.Header>
        <Modal.Title>Activation Link</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Thanks for registering with us. <br />
          <br />
          Account Activation Link :{" "}
          <span className="text-break">
            <a href={addUserEmailModal?.link} target="_blank">
              {addUserEmailModal?.link}
            </a>
          </span>{" "}
          <br />
          <br />
          Please click on the link or browse to above link to activate the account.
        </p>
      </Modal.Body>
    </Modal>
  );
};
